import React from 'react';
import { useSalePeriod } from 'hooks';

export default Component => props => (
    <Component {...props} isSalePeriod={useSalePeriod()} />
);
